import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TrxservicesAchPage } from './trxservices-ach.page';

const routes: Routes = [
  {
    path: '',
    component: TrxservicesAchPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class TrxservicesAchPageRoutingModule {}
